/// <reference path="../../../../rcwebmodels/userlogindetails.cs.d.ts" />
import { fetch, addTask } from 'domain-task';
import { Action, Reducer, ActionCreator } from 'redux';
import { AppThunkAction } from './';
import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
var Config: any = require('../Config.json');
// -----------------
// STATE - This defines the type of data maintained in the Redux store.
export interface UserState {
    isLoading: boolean;
    userName: string;
    passWord: string;
    loggedInUserData: server.UserLoginDetails,
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface RequestValidateUserAction {
    type: 'REQUEST_VALIDATE_USER';
    userName: string;
    passWord: string;
}

interface ReceiveValidateUserAction {
    type: 'RECEIVE_VALIDATE_USER';
    userName: string;
    passWord: string;
    loggedInUserData: server.UserLoginDetails
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
type KnownAction = RequestValidateUserAction | ReceiveValidateUserAction;

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = {
    requestValidateUser: (userName: string, passWord: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        // Only load data if it's something we don't already have (and are not already loading)
        let fetchTask = fetch(Config.ApiBaseUrl + '/api/AuthUser/ValidateUser', { method: 'POST', body: JSON.stringify({ "Username": userName, "Password": passWord }), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } })
            .then(response => response.json() as Promise<server.UserLoginDetails>)
            .then(data => {
                if (data.Errmsg == null || data.Errmsg == "")
                    dispatch({ type: 'RECEIVE_VALIDATE_USER', userName: userName, passWord: '', loggedInUserData: data });
                else {
                    PopupWindow.showErrorMessage("Login", data.Errmsg);
                    dispatch({ type: 'RECEIVE_VALIDATE_USER', userName: userName, passWord: '', loggedInUserData: data });
                }
            });
        addTask(fetchTask); // Ensure server-side prerendering waits for this to complete
        dispatch({ type: 'REQUEST_VALIDATE_USER', userName: userName, passWord: passWord });
    }
};

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
const unloadedState: UserState = { isLoading: true, userName: '', passWord: '', loggedInUserData: null };

export const reducer: Reducer<UserState> = (state: UserState, incomingAction: Action) => {
    if (state === undefined) {
        return unloadedState;
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'REQUEST_VALIDATE_USER':
            return {
                userName: action.userName,
                passWord: action.passWord,
                isLoading: true,
                loggedInUserData: state.loggedInUserData,
            };
        case 'RECEIVE_VALIDATE_USER':
            // Only accept the incoming data if it matches the most recent request. This ensures we correctly
            // handle out-of-order responses.
            if (action.userName === state.userName) {
                return {
                    userName: action.userName,
                    passWord: '',
                    loggedInUserData: action.loggedInUserData,
                    isLoading: false
                };
            }
            break;
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }
    return state;
};
